import { c as _c } from "react/compiler-runtime";
import { Modal } from "@website/ui/modal";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { Login } from "@website/widget/login/login";
import { useLoginModal } from "@website/widget/login/use-login-modal";
export const LoginModal = () => {
  const $ = _c(9);
  const {
    onClose,
    open,
    onLoginModalEnd,
    isForceLogin
  } = useLoginModal();
  const router = useCompatRouter();
  const {
    isWelcomeScreen
  } = router.query as Record<string, string>;
  const t0 = Boolean(isWelcomeScreen);
  let t1;
  if ($[0] !== isForceLogin || $[1] !== onClose || $[2] !== onLoginModalEnd || $[3] !== t0) {
    t1 = <Login onClose={onClose} onEndAuth={onLoginModalEnd} isWelcomeScreen={t0} isForceLogin={isForceLogin} />;
    $[0] = isForceLogin;
    $[1] = onClose;
    $[2] = onLoginModalEnd;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== onClose || $[6] !== open || $[7] !== t1) {
    t2 = <Modal className="scroll-mt-[100px]" mobileHeight="auto" animate="normal" onClose={onClose} open={open} usePortal={true}>{t1}</Modal>;
    $[5] = onClose;
    $[6] = open;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};